/**
 * Re-writes href to link to the new HelpCenter.
 * For example: https://get.todoist.help/hc/articles/360012582940 will be rewrited
 * to /hc/articles/360012582940.
 **/

const excludedPatterns = ['/article_attachments/']

export function rewriteUrl(url: string) {
    const containsExcludedPattern = excludedPatterns.some((p) => url.includes(p))
    if (containsExcludedPattern) {
        return url
    }
    return url.replace(/^https:\/\/(get\.todoist\.help|support\.todoist\.com)/, '')
}
